<svg
  width="16"
  height="12"
  viewBox="0 0 16 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.07904 8.94848L1.52576 5.3952L0 6.92096L5.07904 12L15.5533 1.52576L14.0275 0L5.07904 8.94848Z"
    fill="currentColor"
  />
</svg>
